import React from 'react';
import { List, Typography } from 'antd';
import { colorPrimary, colorRed } from '../styles/styles';

const TogglDetails = ({ projectList }: { projectList: { name: string; time: number; }[] }) => {
  return (
    <List
      split={false} 
      dataSource={projectList}
      renderItem={(project) => {
        return (
          <List.Item key={ project.name }>
            <>
              {project.name === 'UNKNOWN_PROJECT_null' ? (
                <Typography.Text strong style={ colorRed }>
                  NO PROJECT:
                </Typography.Text>
              ) : (
                <Typography.Text strong>{ project.name }:</Typography.Text>
              )}
              <Typography.Text strong style={ colorPrimary }>
                { project.time } h
              </Typography.Text>
            </>
          </List.Item>
        );
      }}
    />
  );
};

export default TogglDetails;
